import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Drawer } from '@material-ui/core';
import Button from 'src/ui/library/Button';
import Cancel from '@material-ui/icons/Cancel';
import SelectWrapper from 'src/ui/library/SelectWrapper';
import DashboardCard from 'src/ui/library/DashboardCard';
import Spinner from 'src/ui/library/Spinner/Spinner';
import intl from 'react-intl-universal';
import { components } from 'react-select';

class AddCaseDrawer extends React.Component {
  render() {
    const { onClose, open, caseLookupValues, selectedCases, onCaseSelect, isAddingCase, isLoadingCases } = this.props;

    const renderValue = props => {
      const { label } = props.data;
      return (
        <components.MultiValueLabel {...props}>
          <span className="label">{`${label}`} </span>
        </components.MultiValueLabel>
      );
    };

    const renderRemove = props => {
      return (
        <components.MultiValueRemove {...props}>
          <Cancel className="del-icon" />
        </components.MultiValueRemove>
      );
    };

    return (
      <Drawer anchor="right" open={open} onClose={onClose}>
        <DashboardCard title={intl.get('cases.documentCases.addButton')} size="drawer">
          {isAddingCase || isLoadingCases ? (
            <Spinner size={70} />
          ) : (
            <Fragment>
              <div className="case-tab-cases-select">
                <SelectWrapper
                  label={intl.get('documents.documentUpload.cases.title')}
                  placeholder={intl.get('documents.documentUpload.cases.selectLabel')}
                  options={caseLookupValues.map(c => ({ value: c.id, label: c.name }))}
                  value={selectedCases}
                  renderValue={renderValue}
                  renderRemove={renderRemove}
                  multi
                  onChange={onCaseSelect}
                />
              </div>
              <div className="dashboard-card-footer">
                <Button styleType="primary" onClick={onClose} disabled={selectedCases.length === 0}>
                  {intl.get('default.label.submit')}
                </Button>
              </div>
            </Fragment>
          )}
        </DashboardCard>
      </Drawer>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddCaseDrawer);
